import {useQuery} from 'react-query';
import {getSubBrandOwner} from '.';

type UseGetSubBrandOwnerProps = {
  brandId?: number;
  enabled?: boolean;
};

const useGetSubBrandOwner = ({
  brandId,
  enabled = true,
}: UseGetSubBrandOwnerProps) => {
  const {data, isLoading} = useQuery({
    queryKey: ['subbrand-owner', brandId],
    queryFn: () => getSubBrandOwner(brandId as number),
    enabled: !!brandId && enabled,
  });

  return {data, isLoading};
};

export default useGetSubBrandOwner;
